import Confetti from './Confetti'
export { type ConfettiProps } from './Confetti'
export default Confetti
